import n from "../atom/theme.mjs";
import c from "../atom/user.mjs";
import l from "react";
import { RecoilRoot as p } from "recoil";
const f = (i) => {
  const { children: a, initState: t, override: m = !0 } = i;
  return /* @__PURE__ */ l.createElement(
    p,
    {
      override: m,
      initializeState: ({ set: e }) => {
        if (t) {
          const { user: r, theme: o } = t;
          o && e(n, o), r && e(c, r);
        }
      }
    },
    a
  );
}, S = f;
export {
  S as default
};
